
const settings = JSON.parse(process.env.VUE_APP_OIDC_CONFIG);
export const oidcSettings = settings;
